export class CurrLotteryModel {
    LotteryCode: string;
    LotteryName: string;
    LotteryTypeCode: string;
    LotteryTypeName: string;
    OpenLength: number;
    NumLength: number;
    IsAuto: boolean;
    LotteryPlayModeCode: string;
    LotteryPlayModeName: string;
    RewardUp: number;
    RewardDown: number;
    BlockTime: number;
    HasMorePlayModeType: number;
    //玩法类别
    PlayMode: PlayModeModel;
    //玩法类别组
    PlayModes: PlayModeModel[];
    currentLotteryType: number;
}


export class PlayModeModel {
    LotteryPlayModeCode: string;
    LotteryPlayModeName: string;
    LotteryCode: string;
    State: string;
    SerialsID: number;
    IsSelect: boolean;
    PlayModeType: number
    LotteryPlayModeTypeCode: number;
    //玩法细则组
    PlayDetails: PlayDetailModel[];
}

export class PlayDetailModel {
    LotteryPlayDetailCode: string;
    LotteryPlayDetailName: string;
    LotteryPlayModeCode: string;
    State: string;
    SerialsID: number;
    AlgorithmCode: string;
    CardinalMoney: number;
    Modulus: number;
    CardinalMoney1: number;
    Modulus1: number;
    LimitBet: number;
    IsRewardFixed: boolean;
    IsAttached: boolean;
    PlayGroup: string;
    Algorithm: AlgorithmModel;
    PlayDetailAttacheds: PlayDetailAttachedModel[];
}

export class PlayDetailAttachedModel {
    NumKey: string;
    LotteryPlayDetailCode: string;
    CardinalMoney: number;
    Modulus: number;
    SerialsID: number;
}


export class AlgorithmModel {
    AlgorithmCode: string;
    AlgorithmName: string;
    SerialsID: number;
    AlgorithmTypeCode: string;
    BetNumLength: number;
    TipInfo: string;
    PickExample: string;
    AlgorithmType: AlgorithmTypeModel;
}


export class AlgorithmTypeModel {
    AlgorithmTypeCode: string;
    AlgorithmTypeName: string;
    State: string;
    LotteryTypeCode: string;
    SerialsID: number;
    PickMode: string;
    CanCommonRan: string;
}

export class IssueModel {
    BeginTime: Date;
    BeginTime1: Date;
    Crossdays: boolean;
    EndTime: Date;
    EndTime1: Date;
    IssueNo: string;
    LotteryCode: string;
    LotteryTypeCode: string;
    MaxIssue: number;
    MinIssue: number;
    NowIssueDay: Date;
}

export class CurrIssue {
    CurrentIssueNo: string;
    PreviewIssueNo: string;
    RemainTime: number;
    Issue: IssueModel;
}

export class DollerAttr {
    LotteryPlayDetailName: string;
    LotteryPlayDetailCode: string;
    currLotteryPlayDetailName: string;
    BettingOdds: number;
    Modulus: number;
    CardinalMoney: number;
    check: string;
    extendValue?: any;
}

export class AnBetting {
    BetTotal: number;   //投注注数
    Position1: string;
    Position2: string;
    Position3: string;
    SerialNo: number;
    BettingNumber: string;
    BettingMoney: number;
    LotteryPlayCode: string;
    LotteryPlayDetailCode: string;
    BettingOdds: number;
    Position: string;
    Modulus: number;
    CardinalMoney: number;
    Rebate: number;
    RangeValue: number;
}

export class ChaseBetting {
    IssueNo: string;
    Multiple: number;
    PerPrice: number;
    BettingMoney: number
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/models/betting.model.ts